import { configureStore } from '@reduxjs/toolkit';
import contentReducer from './features/content/contentSlice';
import appReducer from './features/app/appSlice';
import healthReducer from './features/health/healthSlice';
import { errorMiddleware } from './middleware/errorMiddleware';

export const store = configureStore({
  reducer: {
    content: contentReducer,
    app: appReducer,
    health: healthReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(errorMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
